import React, { useState } from 'react'
import styled from '@emotion/styled/macro'
import FavoriteIcon from 'assets/Favorite'

const AddFavourite = ({ account, domain, isFavorite, ...props }) => {
  const [isFavorited, setIsFavorited] = useState(isFavorite)

  const onFavorite = e => {
    e.preventDefault()
    const favorites = localStorage.getItem(`favorite_ans_${account}`)
    let data
    if (!isFavorited) {
      setIsFavorited(true)
      if (!favorites) data = [domain?.name]
      else {
        const arr = favorites.split(',')
        data = [...arr, domain?.name]
      }
    } else {
      setIsFavorited(false)
      const arr = favorites.split(',')
      const filteredList = arr.filter(name => name !== domain?.name)
      data = filteredList
    }
    localStorage.setItem(`favorite_ans_${account}`, data)
  }

  return (
    <Button {...props} onClick={onFavorite}>
      <FavoriteIcon isFavorite={isFavorited} />
    </Button>
  )
}

export default AddFavourite

const Button = styled('button')`
  background: transparent;
  border: none;
  width: fit-content;

  svg {
    width: 36px;
    height: 36px;

    &:hover {
      cursor: pointer;
    }
  }
`
